import type React from "react";
import ScheduleTimelineCard from "./ScheduleTimelineCard";

interface TimeData {
  call_time: string;
  departure_time: string;
  arrival_at_venue_time: string;
  setup_from_time: string;
  setup_to_time: string;
  shoot_start_time: string;
  shoot_end_time: string;
  estimated_wrap_time: string;
  back_to_base_time: string;
  unpacking_time: string;
  depart_time: string;
}

interface ScheduleTabProps {
  timeData: TimeData;
}

const ScheduleTab: React.FC<ScheduleTabProps> = ({ timeData }) => (
  <ScheduleTimelineCard timeData={timeData} />
);

export default ScheduleTab;
